import styled from "styled-components";
import { primaryColor } from "../../styles/variables";

const PickListContainer = styled.section`

    width: 100vw;
    min-height: 20vh;
    
    
    h2 {
        text-align: center;
        color: ${primaryColor};
        font-size: 1.5rem;
        font-weight: bold;
        margin-bottom: 1.5rem;
        
    }

    span, input {
        margin-right: 1rem;
    }
    .checked {
        text-decoration: line-through;
    }
    input {
        width: 10vw;
        height: 10vh;
    }
    a {
        
        text-decoration: none;
        color: white;
    }
    ul {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        li {
            font-size: 1rem;
        }
}
`;

const ButtonContainer = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
    a {
        text-decoration: none;
        color: white;
    }
`;

export { PickListContainer, ButtonContainer }